import { IpChangesType } from "@features/management/model";

export const ipAddressChangesData: IpChangesType["ipAddressChanges"] = [
  {
    ipAddress: "172.255.255.254",
    ipStatus: "2",
    maxClients: "1",
    adminAccount: "abcd123",
    ipChangeType: "2",
    registered: "2025-04-30 11:06:21.785 +09:00",
    iCafeId: "08CD5B00-1CFA-E911-8B9F-AC162D722BAF",
    // cclassCount: 0,
  },
  {
    ipAddress: "172.255.255.255",
    ipStatus: "2",
    maxClients: "1",
    adminAccount: "abcd123",
    ipChangeType: "2",
    registered: "2025-04-30 11:06:21.113 +09:00",
    iCafeId: "08CD5B00-1CFA-E911-8B9F-AC162D722BAF",
    // cclassCount: 0,
  },
  {
    ipAddress: "192.255.255.252",
    ipStatus: "2",
    maxClients: "1",
    adminAccount: "abcd123",
    ipChangeType: "3",
    registered: "2025-04-29 15:32:16.717 +09:00",
    iCafeId: "08CD5B00-1CFA-E911-8B9F-AC162D722BAF",
    // cclassCount: 0,
  },
  {
    ipAddress: "192.255.255.253",
    ipStatus: "2",
    maxClients: "1",
    adminAccount: "abcd123",
    ipChangeType: "3",
    registered: "2025-04-29 15:32:16.670 +09:00",
    iCafeId: "08CD5B00-1CFA-E911-8B9F-AC162D722BAF",
    // cclassCount: 0,
  },
  {
    ipAddress: "192.255.255.254",
    ipStatus: "2",
    maxClients: "1",
    adminAccount: "abcd123",
    ipChangeType: "3",
    registered: "2025-04-29 15:32:16.623 +09:00",
    iCafeId: "08CD5B00-1CFA-E911-8B9F-AC162D722BAF",
    // cclassCount: 0,
  },
  {
    ipAddress: "172.255.255.252",
    ipStatus: "2",
    maxClients: "1",
    adminAccount: "abcd123",
    ipChangeType: "2",
    registered: "2025-04-29 15:32:16.592 +09:00",
    iCafeId: "08CD5B00-1CFA-E911-8B9F-AC162D722BAF",
    // cclassCount: 0,
  },
  {
    ipAddress: "172.255.255.253",
    ipStatus: "2",
    maxClients: "1",
    adminAccount: "abcd123",
    ipChangeType: "1",
    registered: "2025-04-29 15:32:16.561 +09:00",
    iCafeId: "08CD5B00-1CFA-E911-8B9F-AC162D722BAF",
    // cclassCount: 0,
  },
  {
    ipAddress: "172.255.255.254",
    ipStatus: "2",
    maxClients: "1",
    adminAccount: "abcd123",
    ipChangeType: "4",
    registered: "2025-04-29 15:32:16.514 +09:00",
    iCafeId: "08CD5B00-1CFA-E911-8B9F-AC162D722BAF",
    // cclassCount: 0,
  },
  {
    ipAddress: "172.255.255.255",
    ipStatus: "2",
    maxClients: "1",
    adminAccount: "abcd123",
    ipChangeType: "3",
    registered: "2025-04-29 15:32:16.483 +09:00",
    iCafeId: "08CD5B00-1CFA-E911-8B9F-AC162D722BAF",
    // cclassCount: 0,
  },
  {
    ipAddress: "172.18.96.224",
    ipStatus: "2",
    maxClients: "1",
    adminAccount: "abcd123",
    ipChangeType: "3",
    registered: "2025-04-29 15:32:16.451 +09:00",
    iCafeId: "08CD5B00-1CFA-E911-8B9F-AC162D722BAF",
    // cclassCount: 0,
  },
];
